import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-white py-12 border-t-2 border-gray-200" data-id="element-214" data-mp="3gf96t1ka0gbl">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-215" data-mp="3ghc5e9zhvhrx">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-216" data-mp="32ovwwtntqrjm">
          <div data-id="element-217" data-mp="36pfv80k4w17c">
            <div className="mb-6" data-id="element-218" data-mp="36oy05797jt10">
              <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8" data-id="element-219" data-mp="36pza18ehm9h5" />
            </div>
            <ul className="space-y-3" data-id="element-220" data-mp="36mskisw8wry">
              <li data-id="element-221" data-mp="3levhp4cmtkh8">
                <Link to="/" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-222" data-mp="3ldaopj5yu9lh">
                  Home
                </Link>
              </li>
              <li data-id="element-223" data-mp="29xvp07mdh3mo">
                <Link to="/how-it-works" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-224" data-mp="2a1jjpa3jzw2z">
                  How It Works
                </Link>
              </li>
              <li data-id="element-225" data-mp="3gbin2t0cjq2c">
                <Link to="/resources" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-226" data-mp="3gc0g7grppo61">
                  Guides
                </Link>
              </li>
              <li data-id="element-227" data-mp="3qazo2x4nlfrz">
                <Link to="/pricing" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-228" data-mp="82qplkz0zfq1">
                  Pricing
                </Link>
              </li>
              <li data-id="element-229" data-mp="hrih5s06by0f">
                <Link to="/about-us" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-230" data-mp="hs1vyzuj26a8">
                  About
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-231" data-mp="msy1tiyfw2ia">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-232" data-mp="mthk50s04swu">
              For You
            </div>
            <ul className="space-y-3" data-id="element-233" data-mp="twxuvjrohse2">
              <li data-id="element-234" data-mp="ytxzdq8vqn32">
                <Link to="/individuals" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-235" data-mp="ytejsg6pcas7">
                  For Individuals
                </Link>
              </li>
              <li data-id="element-236" data-mp="18m3q6wneaygo">
                <Link to="/families" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-237" data-mp="1clmabq7e75ig">
                  For Families
                </Link>
              </li>
              <li data-id="element-238" data-mp="1mktp8htrz87o">
                <Link to="/onboarding" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-239" data-mp="1mkbiusdefdm1">
                  Free Assessment
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-240" data-mp="3tb9jzk35jfr4">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-241" data-mp="3tars0znivnp0">
              Legal
            </div>
            <ul className="space-y-3" data-id="element-242" data-mp="2agewjq0gybaq">
              <li data-id="element-243" data-mp="25onclybtj3tk">
                <Link to="/privacy" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-244" data-mp="25o570b39nd8z">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-245" data-mp="1wpjr6np6icbw">
                <a href="/terms" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-246" data-mp="2tdzl0vzbn7ut">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-247" data-mp="2kc8g3tclv520">
                <a href="/subscription" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-248" data-mp="2kbqai641zehf">
                  Subscription Terms
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-249" data-mp="13y060y90uo79">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-250" data-mp="13y9tof6lgj9s">
              Disclaimer
            </div>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-251" data-mp="2rug5xltbfsre">
              Caveo as a family protection platform does not monitor private
              communications. Please consult with your family before making any
              safety decisions.
            </p>
          </div>
        </div>

        {/* Design Test Pages - Tucked Away */}
        <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-252" data-mp="3bj72jfrodj9w">
          <details className="text-xs text-gray-400" data-id="element-253" data-mp="3bhm43f28pg6r">
            <summary className="cursor-pointer hover:text-gray-500 transition-colors" data-id="element-254" data-mp="3fkaf9tefez6w">
              Design System Tests
            </summary>
            <div className="mt-3 flex flex-wrap gap-4" data-id="element-255" data-mp="31nn6mtd42kl5">
              <Link to="/test/button-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-256" data-mp="36jkox57xq10k">
                Button Colors
              </Link>
              <Link to="/test/color-comparison" className="hover:text-[#631bb7] transition-colors" data-id="element-257" data-mp="1v6i6s5q6t3ea">
                Color Comparison
              </Link>
              <Link to="/test/fonts" className="hover:text-[#631bb7] transition-colors" data-id="element-258" data-mp="1iltcqljf107d">
                Font Test
              </Link>
              <Link to="/test/purple-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-259" data-mp="1rn1c76xo4731">
                Purple Colors
              </Link>
              <Link to="/coming-soon" className="hover:text-[#631bb7] transition-colors" data-id="element-260" data-mp="zwwslahqfo2v">
                Coming Soon Page
              </Link>
              <Link to="/marketing" className="hover:text-[#631bb7] transition-colors" data-id="element-261" data-mp="18xbeaaylz56w">
                Marketing Landing Page
              </Link>
              <Link to="/onboarding" className="hover:text-[#631bb7] transition-colors" data-id="element-262" data-mp="g8np44aqnvo2">
                Onboarding Gate
              </Link>
              <Link to="/first-look" className="hover:text-[#631bb7] transition-colors" data-id="element-263" data-mp="2l9qexr0fo1ac">
                First Look Results
              </Link>
              <Link to="/quick-assessment" className="hover:text-[#631bb7] transition-colors" data-id="element-264" data-mp="2q2t0pcyyy6fz">
                Quick Assessment
              </Link>
              <Link to="/signup" className="hover:text-[#631bb7] transition-colors" data-id="element-265" data-mp="1xe46lxwbz1dq">
                Signup Flow
              </Link>
              <Link to="/invite-family" className="hover:text-[#631bb7] transition-colors" data-id="element-266" data-mp="278npd4a8c8uo">
                Invite Family
              </Link>
              <Link to="/deep-assessment" className="hover:text-[#631bb7] transition-colors" data-id="element-267" data-mp="3iokpzprfkh7q">
                Deep Assessment
              </Link>
              <Link to="/assessment-score" className="hover:text-[#631bb7] transition-colors" data-id="element-268" data-mp="1b22mnrnbmi3f">
                Assessment Score
              </Link>
              <Link to="/dashboard" className="hover:text-[#631bb7] transition-colors" data-id="element-269" data-mp="129r40ryg7yy0">
                Guardian Dashboard
              </Link>
              <Link to="/member-dashboard" className="hover:text-[#631bb7] transition-colors" data-id="element-270" data-mp="sdxnyylitnbh">
                Member Dashboard
              </Link>
              <Link to="/learn/module-7" className="hover:text-[#631bb7] transition-colors" data-id="element-271" data-mp="jd7q7pcp9mv4">
                Module 7: Scam Recognition
              </Link>
            </div>
          </details>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center" data-id="element-272" data-mp="28r4jvgcsl1ka">
          <div className="mb-4 md:mb-0" data-id="element-273" data-mp="1hm0fy9i8jjjn">
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-274" data-mp="1hmab0bi50gw7" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-275" data-mp="17u4jf2vss1hj" />
          </div>
          <div className="text-sm text-gray-500" data-id="element-276" data-mp="12xdvxuhny3m3">
            © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}